module.exports = __webpack_public_path__ + "img/desktop-VTA-valoracion-reagendada.563ff8fd.png";